import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { supabase } from '@/lib/supabase'
import { SiteSettingsForm } from '@/components/admin/site-settings-form'
import { Loader2 } from 'lucide-react'

export function AdminSettingsPage() {
  const [settings, setSettings] = useState<Record<string, unknown>>({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    async function fetchSettings() {
      const { data } = await supabase.from('site_settings').select('*')
      const settingsMap: Record<string, unknown> = {}
      data?.forEach((item) => {
        settingsMap[item.key] = item.value
      })
      setSettings(settingsMap)
      setIsLoading(false)
    }
    fetchSettings()
  }, [])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Settings | Admin</title>
      </Helmet>
      <div className="space-y-4 sm:space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Settings</h1>
          <p className="text-muted-foreground mt-1">
            Configure your store settings
          </p>
        </div>

        <SiteSettingsForm settings={settings} />
      </div>
    </>
  )
}
